import React, { useEffect, useState } from "react";
import "./Home_SectionFour.scss";
import { getByStyle } from "../../../services/home/home";
import { Link } from "react-router-dom";
import { Col, Row } from "antd";

function Home_SectionFour() {
  const [byStyle, setByStyle] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentByStyle = await getByStyle();
      setByStyle(contentByStyle);
      //   console.log(contentByStyle);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="home-sectionFour">
        <div className="container">
          <div className="home-sectionFour-wrapper">
            {byStyle.length > 0 && (
              <React.Fragment>
                <div className="box-head">Mua sắm theo phong cách</div>

                <Row gutter={[30, 30]} className="by-style">
                  {byStyle.map((item) => (
                    <Col xxl={8} xl={8} sm={12} key={item.id}>
                      <Link to="/products" className="by-style-item">
                        <div className="inner-main">
                          <div className="img">
                            <img src={item.thumbnail} alt="By Style Img" />
                          </div>
                          <div className="title">{item.title}</div>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home_SectionFour;
